<div class="background">

    <mat-card class="season-manager-card">
        <div class="analysis-sequence-header-container">
        <div class="sequence-field-info">
            <p class="analysis-sequence-header-text">Custom Map Sequence View</p>

            <div class="field-info-text-container">
                <span class="field-detail-title">Field Name: </span>
                <span>{{currentFieldName || '-'}}</span>
                <span> | </span>
                <span class="field-detail-title">Field Size: </span>
                <span>{{currentFieldSize ? (currentFieldSize | number: '1.2-2') : '-'}} HA</span>
            </div>
        </div>

        <!-- Select Items button (replaces multi-select) -->
        <div>
            <button class="select-items-button" mat-flat-button (click)="openSelectItemsDialog()">
                SELECT MAPS
            </button>
        </div>

        <div>
            <mat-slide-toggle [(ngModel)]="showLegends" (change)="toggleLegends()">Toggle Legends</mat-slide-toggle>
        </div>

            <div class="zoom-controls">
                <button class="clear-all-btn" *ngIf="selectedSequenceItems.length > 0" mat-stroked-button (click)="clearAllSelectedSequenceCards()">Clear All</button>
                <button class="zoom-btn" mat-icon-button (click)="zoomIn()" title="Zoom In"><img src="../../assets/icons/zoom_in.svg" alt="Add Icon" class="move-job-icon"></button>
                <button class="zoom-btn" mat-icon-button (click)="zoomOut()" title="Zoom Out"><img src="../../assets/icons/zoom_out.svg" alt="Add Icon" class="move-job-icon"></button>
                <button class="zoom-btn reset-btn" mat-icon-button (click)="resetMaps()" title="Reset Maps"><img src="../../assets/icons/reset.svg" alt="Add Icon" class="move-job-icon"></button>
            </div>

        <div class="input-container-grid">
            <mat-form-field appearance="outline" class="form-field-mini">
                <mat-select [(value)]="gridSize">
                    <mat-option [value]="2">2 x row</mat-option>
                    <mat-option [value]="3">3 x row</mat-option>
                    <mat-option [value]="4">4 x row</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="input-container-close">
                <div class="close-icon-container-sequence"><img src="../../../assets/icons/close.svg" alt="Icon description"
                class="close-icon-sequence" (click)="closeSequenceView()"></div>
        </div>
    </div>

    <!-- Selected items chips -->
    <div class="selected-items-container" *ngIf="selectedSequenceItems.length > 0">
        <div class="selected-item-chip" *ngFor="let item of selectedSequenceItems">
            <p class="selected-item-name">{{item.type}} - {{formatDate(item.datePerformed, 'YYYY-MM-DD')}}
                <span *ngIf="!item.type.toLowerCase().includes('satellite') && !item.type.toLowerCase().includes('topography') && item.items[0]?.propertyTypeName"> | {{item.items[0].propertyTypeName}}</span>
            </p>
            <div class="remove-selected-item" (click)="removeSelectedItem(item)">x</div>
        </div>
    </div>

    <div class="analysis-sequence-container">
        <div *ngIf="cards.length > 0" class="sequence-card-container"
            [style.grid-template-columns]="'repeat(' + gridSize + ', minmax(0, 1fr))'">
            <app-sequence-card *ngFor="let card of cards" [card]="card"></app-sequence-card>
        </div>

        <div *ngIf="cards.length === 0" class="sequence-card-container">
            <div class="sequence-no-items-message-container">
                <div class="sequence-no-items-message">Select analysis items to build your custom sequence.</div>
            </div>
        </div>
    </div>
    </mat-card>

</div>
